module.exports = __webpack_public_path__ + "media/fonts/Roboto-BoldItalic-ad2445ca4e46908fbf7bb4e0fff71139.ttf";